import React, { useState } from "react";
import Chevron from '../Assests/Chevron.svg';
import Uparrow from '../Assests/Uparrow.svg';

const Accordion = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const styles = {
    accordion: {
      borderRadius: "0.9vh",
      marginBottom: "1.6vh",
      overflow: "hidden",
      width: "100%",
      minWidth: "10vh", // Adjust as needed
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "1.2vh 1.6vw",
      backgroundColor: isOpen ? "rgba(41, 104, 254, 0.50)" : "rgba(255, 255, 255, 0.08)",
      cursor: "pointer",
      fontWeight: "bold",
      // borderBottom: isOpen ? "1px solid #ddd" : "none",
    },
    title: {
      fontSize: "1.6vh",
      display: "flex",
      alignItems: "center",
      gap: "0.8vh",
    },
    icon: {
      fontSize: "1.8vh",
      transition: "transform 0.3s ease", // Add rotation animation to the icon
      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", // Rotate the icon
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "2.4vh",
      height: "2.4vh",
    },
    content: {
      padding: isOpen ? "1.6vh" : "0 1.6vw", // Adjust padding for animation
      backgroundColor: "rgba(255, 255, 255, 0.08)",
      maxHeight: isOpen ? "50vh" : "0", // Adjust max-height for animation
      overflow: "auto",
      transition: "all 0.3s ease", // Smooth transition for max-height and padding
      opacity: isOpen ? 1 : 0, // Fade in/out effect
    },
  };

  return (
    <div style={styles.accordion}>
      <div style={styles.header} onClick={toggleAccordion}>
        <span style={styles.title}>{title}</span>
        <span style={styles.icon}>
          {isOpen ? (
            <img className="arrow" src={Uparrow} alt="Arrow" style={{ width: '1.8vh', height: '1.8vh' }} />
          ) : (
            <img className="arrow" src={Chevron} alt="Arrow" style={{ width: '1.8vh', height: '1.8vh' }} />
          )}
        </span>
      </div>
      <div style={styles.content}>
        {children}
      </div>
    </div>
  );
};

export default Accordion;